
document.addEventListener("DOMContentLoaded", () => {
  // Get references to the elements

  setTimeout(() => {
    initializeStoreSelection();
  }, 2000);
});

function createYourStoreTab(storeInfo) {
  const deliveryTabText = document.querySelector('.deliveryTab-right-hand-side');
        const clickAndCollectTabText = document.querySelector('.click-and-collect');
        const clickAndCollectInput = document.querySelector('#click-collect-value');
        // deliveryTabText.innerHTML = storeInfo.isDeliveryAvailable ? 'In stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#85CA6D"/></svg>' : 'Out of stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#E45F5F"/></svg>';
        clickAndCollectTabText.innerHTML = storeInfo.isPickupAvailable ? 'In stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#85CA6D"/></svg>' : 'Out of stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#E45F5F"/></svg>';
        clickAndCollectInput.value = storeInfo.isPickupAvailable ? 'In stock' : 'Unavailable';

  console.log(storeInfo)

  const yourStoreContainer = document.createElement('div');
  const buttonAddCart = document.querySelector('.btn-container .btn--add-to-cart')
  yourStoreContainer.className = 'yourStoreTab';
  yourStoreContainer.style.display = 'flex';
  yourStoreContainer.style.backgroundColor = '#F6F5F3';
  yourStoreContainer.style.paddingBottom = '10px';
  yourStoreContainer.style.cursor = 'pointer';

  if (!storeInfo.isPickupAvailable && !storeInfo.isDeliveryAvailable ) {
    buttonAddCart.disabled = true
    buttonAddCart.textContent = 'OUT OF STOCK'
  } else {
    buttonAddCart.disabled = false
    buttonAddCart.textContent = 'ADD TO BAG'
  }
  
  const storeAvailabilitiesList = document.querySelector(
      ".store-availabilities-list"
    );
  const selectWrapper = document.querySelector(".selectWrapper");
  const stateDropdown = document.getElementById('store_location_state');

  function animateToggle(element) {
    if (window.getComputedStyle(element).display === 'none') {
      element.style.display = 'block';
      let fullHeight = element.scrollHeight + 'px';
      element.style.height = '0';
      setTimeout(() => element.style.height = fullHeight, 10);
    } else {
      element.style.display = 'none';
      element.style.height = '';
    }
  }

  yourStoreContainer.addEventListener("click", () => {
    if(selectWrapper) animateToggle(selectWrapper);
    if(storeAvailabilitiesList) {
      if (stateDropdown && stateDropdown.value && stateDropdown.value !== "") {
        storeAvailabilitiesList.style.display = storeAvailabilitiesList.style.display === "none" ? "block" : "none";
      } else {
        storeAvailabilitiesList.style.display = "none";
      }
    }
  });

  const iconURL = 'https://cdn.shopify.com/s/files/1/1879/3419/files/Screenshot_2023-09-06_at_3.15_1.svg?v=1698249936';

  const yourStoreText = document.createElement('span');
  yourStoreText.style.fontFamily = 'Montserrat';
  yourStoreText.style.fontSize = '12px';
  yourStoreText.style.fontWeight = '600';
  yourStoreText.style.lineHeight = '16px';
  yourStoreText.style.letterSpacing = '0.2px';
  yourStoreText.style.marginLeft = '15px';
  yourStoreText.textContent = 'Your Store: ';

  const svgMarkup = `<svg aria-label="Edit icon" class="icon icon-edit" width="14" height="14" xmlns=" http://www.w3.org/2000/svg " viewBox="0 0 14 14"><path d="M3.09,9.11l6-6a.59.59,0,0,1,.83,0l1,1a.57.57,0,0,1,0,.82l-6,6a.58.58,0,0,1-.41.17H2.92V9.52A.58.58,0,0,1,3.09,9.11Z" fill="none" stroke="currentColor" vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8,4.18,9.82,6" fill="none" stroke="currentColor" vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;

  const storeIconContainer = document.createElement('div');
  storeIconContainer.style.width = '15px';
  storeIconContainer.style.margin = '-6px 5px 0 11px';
  storeIconContainer.innerHTML = svgMarkup;

  const storeName = document.createElement('span');
  storeName.style.color = '#000';
  storeName.style.fontFamily = 'Montserrat';
  storeName.style.fontSize = '12px';
  storeName.style.fontWeight = '500';
  storeName.style.letterSpacing = '0.2px';
  storeName.style.textDecoration = 'underline';
  storeName.style.marginTop = '-2px';
  storeName.textContent = storeInfo.storeName;

  yourStoreContainer.appendChild(yourStoreText);
  yourStoreContainer.appendChild(storeIconContainer);
  yourStoreContainer.appendChild(storeName);

  const storeSelector = document.querySelector('.custom-select-hybrid-stores');
  const clickAndCollectTab = document.querySelector('.clickAndCollectTab');
  storeSelector.insertBefore(yourStoreContainer, clickAndCollectTab.nextSibling);

  // Check for stock availability and add the 'Out of Stock' message
  if (storeInfo.isPickupAvailable === false) {
    const outOfStockContainer = document.createElement('div');
    outOfStockContainer.className = 'outOfStockContainer';
    outOfStockContainer.style.display = 'flex';
    outOfStockContainer.style.backgroundColor = '#F6F5F3';
    outOfStockContainer.style.marginTop = '20px';
    outOfStockContainer.style.fontFamily = "Montserrat";
    outOfStockContainer.style.fontSize = '12px';
    outOfStockContainer.style.fontWeight = '500';
    outOfStockContainer.style.lineBreak = '20px';
    outOfStockContainer.style.letterSpacing = '0.2px';
    outOfStockContainer.style.marginTop = '0';
    outOfStockContainer.style.paddingLeft = '15px';
    outOfStockContainer.style.paddingRight = '15px';
    outOfStockContainer.style.flexDirection = 'column';

    const outOfStockText = document.createElement('span');
    outOfStockText.textContent = `Sorry, this product is unavailable at ${storeInfo.storeName}`;

    outOfStockContainer.appendChild(outOfStockText);

    const checkAllStoresButton = document.createElement('a');
    checkAllStoresButton.id = 'checkAllStoresButton';
    checkAllStoresButton.textContent = 'Check all stores';
    checkAllStoresButton.style.marginTop = '10px';
    checkAllStoresButton.style.marginBottom = '20px';
    checkAllStoresButton.style.cursor = 'pointer';
    outOfStockContainer.appendChild(checkAllStoresButton);

    storeSelector.insertBefore(outOfStockContainer, yourStoreContainer.nextSibling);

    const storeAvailabilitiesList = document.querySelector(
      ".store-availabilities-list"
    );
    const selectWrapper = document.querySelector(".selectWrapper");
    const stateDropdown = document.getElementById('store_location_state');

    function animateToggle(element) {
      if (window.getComputedStyle(element).display === 'none') {
        element.style.display = 'block';
        let fullHeight = element.scrollHeight + 'px';
        element.style.height = '0';
        setTimeout(() => element.style.height = fullHeight, 10);
      } else {
        element.style.display = 'none';
        element.style.height = '';
      }
    }

    checkAllStoresButton.addEventListener('click', () => {
      if(selectWrapper) animateToggle(selectWrapper);
      if(storeAvailabilitiesList) {          
        if (stateDropdown && stateDropdown.value && stateDropdown.value !== "") {
           storeAvailabilitiesList.style.display = storeAvailabilitiesList.style.display === "none" ? "block" : "none";
        } else {
          storeAvailabilitiesList.style.display = "none";
        }
      }
    });

    stateDropdown && stateDropdown.addEventListener("change", () => {      
      if(storeAvailabilitiesList) {
        if (stateDropdown.value && stateDropdown.value !== "") {
          storeAvailabilitiesList.style.display = "block";
          let fullHeight = storeAvailabilitiesList.scrollHeight + 'px';
          storeAvailabilitiesList.style.height = '0';
          setTimeout(() => storeAvailabilitiesList.style.height = fullHeight, 10);
        } else {
          storeAvailabilitiesList.style.display = "none";
        }
      }
    });
  }
}

export function initializeStoreSelection() {
  const clickAndCollectTab = document.querySelector(".clickAndCollectTab");
  const storeAvailabilitiesList = document.querySelector(
    ".store-availabilities-list"
  );

  const yourStoreTab = document.querySelector(".yourStoreTab");
  const selectWrapper = document.querySelector(".selectWrapper");
  const stateDropdown = document.getElementById('store_location_state');
  if(storeAvailabilitiesList) storeAvailabilitiesList.style.display = "none";
  if(selectWrapper) selectWrapper.style.display = "none";

  function animateToggle(element) {
    if (window.getComputedStyle(element).display === 'none') {
      element.style.display = 'block';
      let fullHeight = element.scrollHeight + 'px';
      element.style.height = '0';
      setTimeout(() => element.style.height = fullHeight, 10);
    } else {
      element.style.display = 'none';
      element.style.height = '';
    }
  }

  clickAndCollectTab && clickAndCollectTab.addEventListener("click", () => {
    if(selectWrapper) animateToggle(selectWrapper);
    if(storeAvailabilitiesList) {
      if (stateDropdown && stateDropdown.value && stateDropdown.value !== "") {
        storeAvailabilitiesList.style.display = storeAvailabilitiesList.style.display === "none" ? "block" : "none";
      } else {
        storeAvailabilitiesList.style.display = "none";
      }
    }
  });

  stateDropdown && stateDropdown.addEventListener("change", () => {
    if(storeAvailabilitiesList) {
      if (stateDropdown.value && stateDropdown.value !== "") {
        storeAvailabilitiesList.style.display = "block";
        let fullHeight = storeAvailabilitiesList.scrollHeight + 'px';
        storeAvailabilitiesList.style.height = '0';
        setTimeout(() => storeAvailabilitiesList.style.height = fullHeight, 10);
      } else {
        storeAvailabilitiesList.style.display = "none";
      }
    }
  });
  
  // Get references to the relevant elements
  const storeAvailabilitiesListItems = document.querySelectorAll('.store-availability-list__item');
  const deliveryTab_right_hand_side = document.querySelector(".deliveryTab-right-hand-side.click-and-collect");

  function updateYourStoreTab(storeName, isPickupAvailable) {
    const yourStoreTabs = document.querySelectorAll('.yourStoreTab');
    // If there are multiple, remove all but the first
    if (yourStoreTabs.length > 1) {
      yourStoreTabs.forEach((tab, index) => {
        if (index > 0) tab.remove();
      });
    }

    if (yourStoreTabs[0]) {
      const storeNameSpan = yourStoreTabs[0].querySelector('span:last-child');
      if (storeNameSpan) storeNameSpan.textContent = storeName;
    }

    const outOfStockContainer = document.querySelector('.outOfStockContainer');
    if (outOfStockContainer) {
      if (isPickupAvailable === 'true') {
        outOfStockContainer.style.display = 'none';
      } else {
        outOfStockContainer.style.display = 'flex';
      }
    }
  }

  storeAvailabilitiesListItems.forEach((storeItem) => {
    storeItem.addEventListener('click', function() {
      // Existing code for clicking a store

      deliveryTab_right_hand_side.style.display = 'flex';
      
      // Insert the new logic here to hide the divs and save data
      // document.querySelector('.custom-select-hybrid-stores').style.display = 'none';
      // document.querySelector('.selectWrapper').style.display = 'none'
    if(storeAvailabilitiesList)  storeAvailabilitiesList.style.display = 'none'
    if(selectWrapper) selectWrapper.style.display = 'none'


      // Get store info and save to local storage
      const isPickupAvailable = this.querySelector('.is-pickup-available').getAttribute('data-value') === 'true';
      const isDeliveryAvailable = this.querySelector('.is-delivery-available').getAttribute('data-value') === 'true';
      const storeName = this.querySelector('.store-availability-list__location').textContent;
      const productHandle = document.querySelector('[data-product-handle]')
      const importantInfo = {
        storeName,
        isPickupAvailable,
        isDeliveryAvailable,
        productHandle: productHandle.getAttribute("data-product-handle")
      };
      localStorage.setItem('selectedStoreInfo', JSON.stringify(importantInfo));

      const checkAvailabilityTextContainer = document.querySelector('.checkAvailabilityTextContainer');
      checkAvailabilityTextContainer.style.display = 'none';
      const clickAndCollectStockSign = document.querySelector('.clickAndCollect-stock-sign');
      clickAndCollectStockSign.style.display = 'none';
      const parsedInfo = JSON.parse(selectedStoreInfo);
      const yourStoreTab = document.querySelector('.yourStoreTab');
      const outOfStockContainer = document.querySelector('.outOfStockContainer');

      if (yourStoreTab && outOfStockContainer) {
        yourStoreTab.remove()
        outOfStockContainer.remove()
        createYourStoreTab(importantInfo);
      }
      else {
        createYourStoreTab(importantInfo);
      }

      // Update DeliveryTab and ClickAndCollectTab text and color
      const deliveryTabText = document.querySelector('.deliveryTab-right-hand-side');
      const clickAndCollectInput = document.querySelector('#click-collect-value');
      const clickAndCollectTabText = document.querySelector('.click-and-collect');
      deliveryTabText.innerHTML = isDeliveryAvailable ? 'In stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#85CA6D"/></svg>' : 'Out of stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#E45F5F"/></svg>';
      clickAndCollectTabText.innerHTML = isPickupAvailable  ? 'In stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#85CA6D"/></svg>' : 'Out of stock <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="6" fill="#E45F5F"/></svg>';
      clickAndCollectInput.value = isPickupAvailable ? 'In stock' : 'Unavailable';

      const newStoreName = this.querySelector('.store-availability-list__location').textContent.trim();
      const newIsPickupAvailable = this.querySelector('.is-pickup-available').getAttribute('data-value');

      updateYourStoreTab(newStoreName, newIsPickupAvailable);
    });
  });

  const selectedStoreInfo = localStorage.getItem('selectedStoreInfo');
  if (selectedStoreInfo) {
    const currentProduct = document.querySelector('[data-product-handle]').getAttribute("data-product-handle");
    const {productHandle} = JSON.parse(selectedStoreInfo)

    if (currentProduct === productHandle) {
      deliveryTab_right_hand_side.style.display = 'flex';
    
      const checkAvailabilityTextContainer = document.querySelector('.checkAvailabilityTextContainer');
      const clickAndCollectStockSign = document.querySelector('.clickAndCollect-stock-sign');
      checkAvailabilityTextContainer.style.display = 'none';
      clickAndCollectStockSign.style.display = 'none';
      const parsedInfo = JSON.parse(selectedStoreInfo);
      createYourStoreTab(parsedInfo);
    }
  }

  const secondaryActions = document.querySelector('.secondary-actions');

  secondaryActions.style.display = 'block';
}
